import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { TextInputField } from '..';

type TextInputFieldProps = ComponentProps<typeof TextInputField>;

type Props = {
  name: string;
  textInput?: TextInputFieldProps['textInput'];
  fieldWrapperProps: Omit<TextInputFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
};

export const TextInputFieldController: React.FC<Props> = ({
  name,
  fieldWrapperProps,
  textInput,
}) => {
  const { control } = useFormContext();

  const {
    field: { ref, ...restField },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <TextInputField
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
      textInput={{ ...textInput, error: !!error }}
      {...restField}
    />
  );
};
